import { z } from 'zod';

export const CaseTypeDtoSchema = z.object({
  id: z.string(),
  caseTypeId: z.string().nullable().optional(),
  displayName: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  specialty: z.string().nullable().optional(),
  procedureCode: z.string().nullable().optional(),
});
export type CaseTypeDto = z.infer<typeof CaseTypeDtoSchema>;

export const PaginatedCaseTypesResponseDtoSchema = z.object({
  data: z.array(CaseTypeDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedCaseTypesResponseDto = z.infer<typeof PaginatedCaseTypesResponseDtoSchema>;

export interface CaseTypesFilterParams {
  search?: string;
  page?: number;
  limit?: number;
}

export interface CreateCaseTypeDto {
  caseTypeId: string;
  procedureCode: string;
  displayName: string;
  description?: string;
  specialty?: string;
}

export interface UpdateCaseTypeDto {
  procedureCode?: string;
  displayName?: string;
  description?: string | null;
  specialty?: string | null;
}
